import React from 'react'
import VirtualCardDetail, {
  VirtualCardDetailContext,
} from 'src/app/VirtualCardDetail/VirtualCardDetail'

/**
 * Flat-route adapter: binds VirtualCardDetail's myWallet context, since the
 * flat registry requires a prop-less component.
 */
const MyWalletVirtualCardDetailPage: React.FC = () => (
  <VirtualCardDetail context={VirtualCardDetailContext.myWallet} />
)

export default MyWalletVirtualCardDetailPage
